import { DEFAULT_MODAL_DIMENSIONS, openModal } from '../openModal/openModal';
export async function openWaitingListModal(_ref) {
  let {
    serviceType,
    wixCodeApi,
    appParams
  } = _ref;
  const modalType = 'waitlist';
  return openModal({
    wixCodeApi,
    appParams,
    modalType,
    serviceType,
    dimensions: DEFAULT_MODAL_DIMENSIONS
  });
}
//# sourceMappingURL=openWaitingListModal.js.map